import { createTheme } from "@mui/material/styles";

// Light theme definition
export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#f50057",
    },
    background: {
      default: "#f5f5f5",
      paper: "#ffffff",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 500,
    },
    h4: {
      fontWeight: 600,
    },
    button: {
      textTransform: "none",
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 500,
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: 40,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: 40,
          paddingTop: 6,
          paddingBottom: 6,
        },
      },
    },
    MuiGrid: {
      styleOverrides: {
        container: {
          width: '100%',
          margin: 0,
          boxSizing: 'border-box',
        },
        root: {
          boxSizing: 'border-box',
        },
      },
    },
    // NOTE (2026-08-05): there is deliberately no `MuiDialog.styleOverrides.paper`
    // size constraint here any more. It used to set `maxWidth: 90vw` /
    // `maxHeight: 90vh` on every dialog in the app, which was actively harmful:
    //
    //   MUI applies theme styleOverrides for the `paper` slot AFTER the
    //   component's own `paperWidthXs/Sm/Md/Lg/Xl` variant styles, so `90vw`
    //   beat the `maxWidth` prop on all ~294 dialogs that declare one. An
    //   `xs` dialog (444px) rendered at 90vw — a confirmation prompt one line
    //   long stretched the full width of the screen. It also beat `fullScreen`,
    //   which is why several dialogs carry `!important` PaperProps overrides.
    //
    // It was never a safety net either: MUI already caps dialog paper at
    // `calc(100% - 64px)` in both axes by default. Don't reintroduce it — set
    // the size on the individual dialog via the `maxWidth`/`fullScreen` props,
    // which now work as documented.
  },
});

// Dark theme definition
export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#90caf9",
    },
    secondary: {
      main: "#f48fb1",
    },
    background: {
      default: "#121212",
      paper: "#1e1e1e",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 500,
    },
    h4: {
      fontWeight: 600,
    },
    button: {
      textTransform: "none",
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 500,
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: 40,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: 40,
          paddingTop: 6,
          paddingBottom: 6,
        },
      },
    },
    MuiGrid: {
      styleOverrides: {
        container: {
          width: '100%',
          margin: 0,
          boxSizing: 'border-box',
        },
        root: {
          boxSizing: 'border-box',
        },
      },
    },
    // NOTE (2026-08-05): no `MuiDialog.styleOverrides.paper` size constraint
    // here either — see the matching note in `lightTheme` above for why it was
    // removed and why it shouldn't come back. Keep the two themes in step.
  },
});

// Helper function to get theme by preference
export const getThemeByPreference = (themePreference) => {
  return themePreference === "dark" ? darkTheme : lightTheme;
};
